window.addEventListener('DOMContentLoaded', function () {
  const topBar = document.querySelector('.top__bar');
  if (!topBar) {
    console.warn('[TopBar] .top__bar element not found.');
    return;
  }

  const closeBtn = topBar.querySelector('.top__bar-close');
  const hasClosed = sessionStorage.getItem('top_bar_closed') === '1';

  if (!hasClosed) {
    topBar.classList.add('is-visible');
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      topBar.classList.remove('is-visible');
      sessionStorage.setItem('top_bar_closed', '1');
    });
  }

  // ✅ Improved scroll show/hide logic with state check
  if (!hasClosed) {
    let scrollTimeout;
    let isHidden = false; // track current visibility state

    window.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        const scrollTop = window.scrollY;

        if (scrollTop > 100 && !isHidden) {
          topBar.classList.add('is-hidden-scroll');
          isHidden = true;
        } else if (scrollTop <= 100 && isHidden) {
          topBar.classList.remove('is-hidden-scroll');
          isHidden = false;
        }
      }, 50);
    });
  }
});
